// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__uZlvS","logo":"footer_logo__sJmb9","docs":"footer_docs__aUHO7"};